import React from 'react'
import { Button, Col, Row, Spinner } from 'react-bootstrap'
import AdminCategoryCard from './AdminCategoryCard'
import { Link } from 'react-router-dom'

const AdminAllCategoryConatiner = ({ AllCategories, loading, searchValue, handleChangeSearchValue }) => {
    return (
        <>
            <div className='d-flex flex-row justify-content-between m-3  mt-5 align-items-center'>
                <h3 className='fw-bold'>All Categories</h3>
                <Link to="/admin/addcategory">
                    <Button className='dark-bg border-0 px-4 py-3'>Add New Category</Button>
                </Link>
            </div>
            <div className='d-flex flex-row justify-content-between mx-3 mb-2 align-items-center'>
                <input type='text' className='form-control h-60 mb-4 fs-20 fw-bold' placeholder='Search by Category name' value={searchValue} onChange={handleChangeSearchValue} />
            </div>
            <Row className='mx-1'>
                {loading === true ? (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
                    <Spinner animation="border" variant="danger" />
                </div>) :
                    (AllCategories?.length >= 1 ?
                        (AllCategories.map((item, index) => {
                            let imageUrl = item.image;
                            if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
                            }
                            else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/', '');
                            }
                            else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
                            }
                            else {
                                imageUrl = item.image;
                            }
                            return (
                                <Col
                                    xl="3"
                                    lg="4"
                                    sm="6">
                                    <AdminCategoryCard
                                        key={index}
                                        title={item.name}
                                        img={imageUrl}
                                        id={item._id}
                                    />
                                </Col>
                            )
                        })) :
                        <div className='d-flex justify-content-center align-items-center flex-column h-100'>
                            <h3 className='alert alert-danger'>No Categories to show, Add new Category to show</h3>
                            <Link to="/admin/addcategory">
                                <Button className='dark-bg border-0 px-4 py-3'>Add New Category</Button>
                            </Link>
                        </div>
                    )}
            </Row>

        </>
    )
}

export default AdminAllCategoryConatiner
